/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:14:04
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { toVisualThousands } from "../utils";
import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";

export default  ({ label, list = [], color = [] }) => {
  return {
    title: {
      // text: 'World Population'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color,
    legend: {
      bottom: 10,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: 60,
      containLabel: true
    },
    xAxis: { type: 'category', axisLabel: { ...xAxisLabelColor } },
    yAxis: { axisLabel: { ...yAxisLabelColor }},
    dataset: [
      {
        source: list,
      },
    ],
    series: Array(label.length).fill(null).map(() => ({
      stack: 'same',
      type: 'bar',
      label: {
        show: true,
        formatter: (ele) => toVisualThousands(ele.value),
        ...labelFont,
      }
    }))
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P19/chart.js